module.exports = __webpack_public_path__ + "static/media/industrial_2.38fadfab.jpg";